import { useMemo } from "react";
import LoyaltyOffer from "../../../utils/LoyaltyOfferClass/LoyaltyOffer";
import { isFixedBundle } from "../../../utils/loyalty/offerShape";
import { useMenuLookups } from "../useMenuLookups";

/**
 * What a fixed bundle's items cost on their own, from the menu this screen is
 * already showing.
 *
 * Undefined for a bundle the guest chooses from — there is no total until they
 * have chosen — and undefined when any item has left the menu, because a total
 * missing a line would understate what the bundle saves. Prices vary by branch
 * and order type, which is why the loyalty service leaves this to the client
 * rather than baking a figure into copy generated once per offer.
 */
export const useFixedBundleSum = (
  offer: LoyaltyOffer | undefined
): number | undefined => {
  const { subItemLookup } = useMenuLookups();

  return useMemo(() => {
    const config = offer?.itemLevelConfig;
    if (!isFixedBundle(config)) {
      return undefined;
    }

    let total = 0;
    for (const entity of config?.targetEntities ?? []) {
      const price = subItemLookup[entity.entityId]?.price;
      if (price == null) {
        return undefined;
      }
      total += price * Math.max(entity.minimumQuantity ?? 1, 1);
    }

    return total;
  }, [offer, subItemLookup]);
};
